enum InvestorTypeEnum {
    Individual = 'INDIVIDUAL',
    JointIndividuals = 'JOINT_INDIVIDUALS',
    Company = 'COMPANY',
    TrustIndividual = 'TRUST/INDIVIDUAL',
    TrustCompany = 'TRUST/COMPANY',
}

export default InvestorTypeEnum;
